import { render, staticRenderFns } from "./AssetDetailView.vue?vue&type=template&id=892b9958&scoped=true"
import script from "./AssetDetailView.vue?vue&type=script&lang=js"
export * from "./AssetDetailView.vue?vue&type=script&lang=js"
import style0 from "./AssetDetailView.vue?vue&type=style&index=0&id=892b9958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b9958",
  null
  
)

export default component.exports